import { render, staticRenderFns } from "./suggestForm.vue?vue&type=template&id=4a456f9c&scoped=true&"
import script from "./suggestForm.vue?vue&type=script&lang=js&"
export * from "./suggestForm.vue?vue&type=script&lang=js&"
import style0 from "./suggestForm.vue?vue&type=style&index=0&id=4a456f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a456f9c",
  null
  
)

component.options.__file = "suggestForm.vue"
export default component.exports